/**
 * Turn WordPress gallery into lightbox slider
 * by adding Elementor gallery widget without images and hidden on all devices to template for single post page.
 * Set el_lightbox here of that created element
 */
export default class Gallery {

    constructor(el_lightbox) {

        this.el_lightbox = el_lightbox;
        this.images = this.get_images();
        
        if(this.images.length > 0) {
            this.add_lightbox_to_link();
        }
    }

    /**
     * Get all images except featured image
     */
    get_images() {
        return document.querySelectorAll('.elementor-widget-theme-post-content img');
    }

    /**
     * Add data-elementor-lightbox-slideshow attr
     */
    add_lightbox_to_link() {
        this.images.forEach((image) => {
            let link = image.parentNode;
            if( link.tagName.toLowerCase() == 'a' ) {
                link.setAttribute('data-elementor-lightbox-slideshow', this.el_lightbox);
            }
        });
    }
}